import API_PATH from '../../../config/API_PATH'
import { RANK_STATUS } from './contants'

export const getRankStatus = data => {
	return {
		type: RANK_STATUS,
		data,
		meta: {
			method: 'GET',
			url: API_PATH.userRankStatus,
			query: data.query || {},
			callback: data.callback || null
		},
	}
}
